/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface AnexoProps {
  nome: string | null;
  anexoBase64: string | null;
}

interface ParamsProps {
  idLead365: string | null | any;
  idLeadCorretor365: string | null | any;
  idTipoTarefa365: string | null | any;
  idEmpreendimento365: string | null | any;
  titulo: string | null | any;
  descricao: string | null | any;
  dataProgramadaRealizacaoTarefa: string | null | any;
  horaProgramadaRealizacaoTarefa: string | null | any;
  inserirTarefaNoOutlook: boolean;
  tokenAd: string | null | any;
  anexo: AnexoProps | null;
  idTipoResultadoTarefa365: string | null | any;
  observacoes: string | null | any;
  dataProgramadaRealizacaoNovaTarefa: string | null | any;
  horaProgramadaRealizacaoNovaTarefa: string | null | any;
  idMotivoDesqualificacaoLead365: string | null | any;
  concluirTarefa: boolean;
  codigoTipoAgendamentoVisita: number | null;
  localRegionalSul: string | null | any;
  idCorretorParceiro365: string | null | any;
  solicitarPresencaEspecialista: boolean;
  idProfissao365: string | null | any;
  idade: string | null | any;
  bairro: string | null | any;
  idUsuarioEspecialista: string | null | any;
  idEmpreendimento365RegionalSul: string | null | any;
  idTemperaturaLead365: string | null | any;
  descricaoNovaTarefa: string | null | any;
  idObjetivoCompra?: string | null;
  // Checkbox "Assinatura" do formulário do Sul: boolean quando aplicável
  // (Sul + apresentarFlagAssinatura), null caso contrário.
  assinatura?: boolean | null;
}

interface Params {
  body: ParamsProps;
}

export function useCadastrarTarefaConcluida(props: Params) {
  const registerData = async () => {
    const CADASTRAR_TAREFA_CONCLUIDA = `${leadsWebEnviroment}/common/tarefas-leads/cadastrar-tarefa-concluida/v1`;
    return await instance.post(CADASTRAR_TAREFA_CONCLUIDA, props?.body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["cadastrar_tarefa_concluida"],
    onSuccess: () => {
      toast.success("Nova tarefa criada com sucesso", {
        autoClose: 10000,
      });
    },
    onError: (error: any) => {
      console.log(error?.response);
      if (error?.response?.status >= 500) {
        toast.error(`Houve um erro: Status: ${error?.response?.status}`, {
          autoClose: 10000,
        });
      } else {
        const errorMessages = error.response.data.notifications.map(
          (item: any) => `\n${item?.message}\n`
        );

        toast.error(errorMessages.join(""), { autoClose: 10000 });
      }
    },
  });
  return query;
}
